// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "./index.css";

import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";

import { appRouter } from "./routes/appRouter";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element (#root) not found");
}

ReactDOM.createRoot(rootEl).render(
  <AuthProvider>
    <ThemeProvider>
      <RouterProvider router={appRouter} />
    </ThemeProvider>
  </AuthProvider>
);